<ng-template #defaultItemTemplate let-item="item">{{ item.text }}</ng-template>
<div class="demo">
  <app-demo-title [config]="context.config"></app-demo-title>
  <div class="actions">
    <ng-content select="[actions]"></ng-content>
  </div>
  <div class="work" *ngIf="!context.noWorkView">
    <div class="viewport-wrapper">
      <div
        class="viewport {{ context.addClass || '' }}"
        id="{{ context.viewportId || context.config.id }}"
      >
        <div *uiScroll="let item of datasource; let index = index">
          <div
            class="item {{ context.addClass || '' }}"
            [style.height]="
              item.hasOwnProperty('size') ? item.size + 'px' : null
            "
          >
            <ng-template
              [ngTemplateOutlet]="itemTemplate || defaultItemTemplate"
              [ngTemplateOutletContext]="{ item: item, index: index }"
            ></ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="log" *ngIf="init() && !context.noInfo">
      <ng-container *ngIf="!context.logViewOnly; then allView; else logView">
      </ng-container>
      <ng-template #allView>
        <div class="elements {{ context.addClass || '' }}">
          Viewport scrollable size:
          <span>{{ metrics().viewportSize }}</span>
        </div>
        <div class="elements {{ context.addClass || '' }}">
          DOM elements count:
          <span>{{ metrics().domElementsCount }}</span>
        </div>
        <div class="datasource {{ context.addClass || '' }}">
          Datasource.get log
          <div class="pre-wrapper">
            <pre>{{ context.log() }}</pre>
          </div>
        </div>
      </ng-template>
      <ng-template #logView>
        <div class="datasource {{ context.addClass || '' }}">
          Datasource.get log
          <div class="pre-wrapper">
            <pre>{{ context.log() }}</pre>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="clearfix mb-3"></div>
  </div>
  <app-demo-sources [sources]="sources"></app-demo-sources>
  <div class="description">
    <ng-content select="[description]"></ng-content>
  </div>
</div>
